import { defineComponent as _defineComponent } from 'vue';
import { useSettingsStore } from '@/store/modules/settings';
import getPageTitle from '@/utils/pageTitle';

import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const {
      locale
    } = useI18n();
    const route = useRoute();
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const {
      changeLanguage
    } = settingsStore;
    const handleCommand = language => {
      changeLanguage(language);
      locale.value = language;
      document.title = getPageTitle(route.meta.title);
    };
    const __returned__ = {
      locale,
      route,
      settingsStore,
      theme,
      changeLanguage,
      handleCommand
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});